import { AxiosResponse } from "axios"
import {IApiResponse} from "@pcgerente-node/pcg-comun";


export class structureInfoState<T>{
  public loading : boolean = true
  public info: T
  public errorUndefined?: string

  constructor(table: T){
    this.info = table
  }
}

/**Establece la informacion presentandolo, en el escenario ideal */
export function limpiarEstado<T>(): structureInfoState<T[]>;
export function limpiarEstado<T>(info: T): structureInfoState<T>;
export function limpiarEstado<T>(info?: T): structureInfoState<T| T[]>{
  if(info === undefined ){
    return {info: [],loading: false, errorUndefined: undefined}
  }
  return {info: info,loading: false, errorUndefined: undefined}
}

/**Setea el estado de redux */
export function establecerEstado<T>(info: T, arrojarErrorSiEsUndefined: boolean = false):structureInfoState<T>{
  if(arrojarErrorSiEsUndefined){
    throw new Error("No se obtuvo respuesta de la base de datos")
  }
  return {info,loading: false, errorUndefined: undefined}
}

/**Limpia la información para que se vuelva a cargar con la página */
export function reestablecerEstado<T>(): structureInfoState<T[]>;
export function reestablecerEstado<T>(info: T): structureInfoState<T>;
export function reestablecerEstado<T>(info?: T): structureInfoState<T[]|T>{
  if(info === undefined )
    return {info:[],loading: true, errorUndefined: undefined} 
  else 
    return {info,loading: true, errorUndefined: undefined} 
}

/**Carga la respuesta por defecto si es undefined, con loading en false*/
export function seteaError<T>(error: Error):structureInfoState<T[]>;
export function seteaError<T>(error: Error, info: T):structureInfoState<T>;
export function seteaError<T>(error: Error, info?: T):structureInfoState<T| T[]>{
  if(info === undefined )
    return {info: [] ,loading: false, errorUndefined: error.message}
  else
    return {info,loading: false, errorUndefined: error.message}
}

/**Esto manejará todas las respuestas de mi backend*/
export function handleResponse<T>(res: AxiosResponse<IApiResponse<T>>): T {
  if (res.data.message) {
    throw new Error(res.data.message);
  }
  return res.data.companion as T;
}

export const baseURL = process.env.REACT_APP_NODE_URL
const token = `Bearer ${process.env.REACT_APP_JWT}`

export const headers ={ 
cache: 'no-cache',
mode: 'cors',
headers: {
    'Accept': 'application/json',
    "Authorization": token
    }
}